/* global ppms */
import * as Sentry from '@sentry/browser';
// import { listen } from 'Models/utils/event-bus';
let cookieAccepted;
export default function initSentry () {
    if (typeof ppms !== 'undefined' && ppms !== undefined) {
        // listen('contact-flyout-opened', settingsSuccessCallback);
        ppms.cm.api('getComplianceSettings', settingsSuccessCallback);
    }
}

function settingsSuccessCallback (data) {
    if (data.consents && data.consents.analytics && data.consents.analytics.status === 1) {
        loadSentry();
    } else {
        cookieAccepted = setInterval(checkForCookies, 1500);
    }
}

function checkForCookies () {
    ppms.cm.api('getComplianceSettings', (event) => {
        if (event.consents && event.consents.analytics && event.consents.analytics.status === 1) {
            clearInterval(cookieAccepted);
            loadSentry();
        }
    });
}

function loadSentry () {
    Sentry.init({
        dsn: 'https://ecb60db648f5f74fe519371e3623844e@o4507483084029952.ingest.de.sentry.io/4507483088486480',
        debug: false,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', 'https://staging.reca.sneakpeek.cc', /^https:\/\/www\.reca\.co\.at/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });

    window.Sentry = Sentry;
}
